import React from 'react';
import { volumes } from '../data/unstuckContent';
export function VolumesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="volumes-title" data-id="element-230" data-mp="3uungiy1xz8fg">
      <div className="mx-auto max-w-5xl px-5" data-id="element-231" data-mp="cp0ykb16my7v">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-232" data-mp="cnpwcfndxyiv">
          Dopamine → Execution
        </p>
        <h2 id="volumes-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-233" data-mp="3g4pxsxms7axn">
          The 6 complete volumes
        </h2>

        <ol className="mt-8 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="3pvsyvzfpnpwx">
          {volumes.map(v => <li key={v.number} className="border border-charcoal-600 bg-charcoal-800 px-5 py-5" data-id="element-235" data-mp="3l2rj7p7ojmca">
              <div className="flex items-baseline justify-between gap-3" data-id="element-236" data-mp="2xd5k11rb574a">
                <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-237" data-mp="2selvqup8rj8r">
                  {v.number}
                </p>
                <p className="text-[9px] font-medium uppercase tracking-[0.18em] text-muted" data-id="element-238" data-mp="29do1o1nxxibr">
                  {v.category}
                </p>
              </div>
              <h3 className="mt-1.5 font-display text-lg font-semibold uppercase leading-tight text-ivory-50" data-id="element-239" data-mp="2j6mpvifiz6uu">
                {v.title}
              </h3>
              <p className="mt-2 text-[14px] leading-snug text-body" data-id="element-240" data-mp="1qgwc5aht26z9">{v.line}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}